module.exports = function() {
  return new Worker(__webpack_public_path__ + "8acc76fdb6ee253c485e.worker.js");
};